module.exports = __webpack_public_path__ + "static/img/conveyor-wall-mount_256.b929c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-wall-mount_256.png
// module id = N4Cq
// module chunks = 0